<template>
  <component
    modal-class="announcement-container"
    name="fade"
    size="lg"
    :hide-header="true"
    :show="showModal"
    @hidden="showModal = false"
    :hide-footer="true"
    :is="isHighPriority ? 'modal' : 'transition'"
    :no-close-on-backdrop="true"
    ref="modal"
  >
    <div class="text-medium" :class="{ 'bottom-dialog': !isHighPriority }">
      <div class="backdrop" v-if="isHighPriority"></div>
      <div class="action-group d-flex align-items-center justify-content-end">
        <link-button class="text-medium p-0" @click="snooze" v-if="isSnoozable"
          >Remind me later</link-button
        >
        <i class="close-rounded-icon ml-2" @click="onClose" v-if="!isRequired"></i>
      </div>
      <div class="text-secondary py-2 content">
        <div v-html="content"></div>
      </div>
    </div>
  </component>
</template>

<script>
import LinkButton from '@/components/buttons/LinkButton'
import Modal from '@/components/Modal'
import * as R from 'ramda'

export default {
  name: 'Announcements',
  components: {
    LinkButton,
    Modal
  },
  data() {
    return {
      showToast: true,
      showModal: true
    }
  },
  computed: {
    announcement() {
      return R.path(['announcement', 'newAnnouncements', '0'], this.$store.state)
    },
    content() {
      return this.announcement?.content
    },
    isRequired() {
      return this.announcement?.isRequired
    },
    isSnoozable() {
      return this.announcement?.isSnoozable
    },
    isHighPriority() {
      return this.announcement?.isHighPriority
    }
  },
  methods: {
    markAnnouncementRead() {
      this.$store.dispatch('announcement/readNewestAnnouncement')
    },
    onClose() {
      if (this.isHighPriority) {
        this.$refs.modal.hide()
      }
      this.markAnnouncementRead()
    },
    snooze() {
      this.$store.dispatch('announcement/snoozeAnnouncement')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';
@import '~@/styles/animations/fade';

.bottom-dialog {
  position: fixed;
  bottom: 35px;
  right: 35px;
  max-width: 440px;
  min-width: 320px;
  box-shadow: 0px 10px 40px rgba(0, 0, 0, 0.1), 0px 4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 18px 26px;
  background-color: $documentColor;
  z-index: 2;
}

.close-rounded-icon {
  height: 22px;
  width: 22px;
}

.content {
  padding-left: 14px;
}
</style>

<style lang="scss">
.announcement-container {
  width: fit-content;
  .modal-content {
    min-width: 400px;
  }
}
</style>
